module.exports = __webpack_public_path__ + "img/3.547e13ff.jpg";